import styled from 'styled-components';

export const WrapperPersonalInformation = styled.div`
  > h1 {
    margin-bottom: 24px;
    color: #161d1f;
    font-size: 18px;
    font-weight: 700;
    line-height: 28px;
  }

  > p {
    margin-bottom: 8px;
    color: #161d1f;
    font-size: 14px;
    line-height: 20px;
  }
`;

export const WrapperInputToggle = styled.div`
  width: 100%;
  padding: 24px;
  display: grid;
  gap: 16px;
  grid-template-columns: 100%;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 #eaeef1;
`;

export const SwitchHeader = styled.div`
  > p {
    font-family: Lato;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    margin-right: 8px;
  }
`;

export const SwitchContainer = styled.div`
  > div {
    &:first-child {
      display: flex;
      align-items: center;

      label {
        display: block;
        width: 36px;
        height: 16px;
        background: #7a959f;
        position: relative;
        border-radius: 9px;
        margin: 8px;
        cursor: pointer;

        &:before {
          content: '';
          height: 20px;
          width: 20px;
          background: #ffffff;
          position: absolute;
          border: 3px solid #7a959f;
          top: 50%;
          left: 0px;
          transform: translateY(-50%);
          border-radius: 50%;
          transition: 0.5s ease all;
        }
      }

      input {
        display: none;
        &:disabled {
          pointer-events: none;
        }
        &:checked + label:before {
          left: 16px;
          border-color: #4318cd;
        }
        &:checked + label {
          background: #4318cd;
        }
      }

      span {
        font-family: lato;
        color: #4f6168;
        font-weight: 400px;
        font-size: 14px;
      }
      > div {
        display: flex;
        align-items: center;
      }
    }
  }
`;

export const SwitchContent = styled.div``;
